import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import Home from './components/Home';
import Features from './components/Features';
import Prices from './components/Prices';
import Footer from './components/Footer';
import Uploading from './components/FileUpload';
import FilesPrev from './components/FilesPrev';
import PartScore from './components/Halfscore';
import PayScreen from './components/PayScreen';
import FullScore from './components/FullScore';
import ProtectedRoute from './components/ProtectedRoute';
import toast, { Toaster } from 'react-hot-toast';
import NotFound from './components/Page404';
import SignupPage from './components/signin';
import LoginPage from './components/signup';
import axios from 'axios';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Home1 from './components/Home1';
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

axios.defaults.withCredentials = true;

const DynamicPaddingWrapper = ({ children }) => {
    const location = useLocation();
    const paddingClass = location.pathname === '/home' ? 'sm:pt-[84px]' : 'sm:pt-[88px]';
    return <main className={`flex-grow pt-16 ${paddingClass}`}>{children}</main>;
};



const App = () => {
    return (
        <div className="flex flex-col min-h-screen">
            <Router>
                <Toaster
                    position="top-right"
                    toastOptions={{
                        duration: 2000,
                        style: {
                            marginTop: '88px',
                        },
                    }}
                />
                <DynamicPaddingWrapper>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/home" element={<Home1 />} />
                        <Route path="/features" element={<Features />} />
                        <Route path="/pricing" element={<Prices />} />
                        <Route path="/upload" element={<Uploading />} />
                        <Route path="/signin" element={<LoginPage />} />
                        <Route path="/signup" element={<SignupPage />} />
                        <Route
                            path="/filesPreview"
                            element={
                                <ProtectedRoute element={<FilesPrev />} requiredStep="upload" />
                            }
                        />
                        <Route
                            path="/partScore"
                            element={
                                <ProtectedRoute element={<PartScore />} requiredStep="filesPreview" />
                            }
                        />
                        <Route
                            path="/pay"
                            element={
                                <ProtectedRoute element={<PayScreen />} requiredStep="partScore" />
                            }
                        />
                        <Route
                            path="/fullScore"
                            element={
                                <ProtectedRoute element={<FullScore />} requiredStep="pay" />
                            }
                        />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </DynamicPaddingWrapper>
                <Footer />
            </Router>
        </div>
    );
};

export default App;
